import register from '../register';
import { getBreakpoint } from './util/breakpoint';
import debounce from './util/debounce';

function appendStylesheet() {
  let src = 'https://assets.calendly.com/assets/external/widget.css';
  let el = document.querySelector('.calendly--mobile');
  let link = document.createElement('link');
  link.setAttribute( 'rel', 'stylesheet' );
  link.setAttribute( 'type', 'text/css' );
  link.setAttribute( 'id', 'calendly-mobile-styles' );
  link.setAttribute( 'href', src );
  el.appendChild( link );
}

function removeStylesheet() {
  const link = document.getElementById('calendly-mobile-styles');
  link.parentElement.removeChild( link );
}

register( 'calendly-meeting', () => {

  let added = false;

  function init() {
    let breakpoint = getBreakpoint();

    if ( breakpoint === 'small' ) {
      appendStylesheet();
      added = true;
    }
  }

  function onResize() {
    let breakpoint = getBreakpoint();

    if ( breakpoint !== 'small' && added ) {
      removeStylesheet();
      added = false;
    }

    if ( breakpoint === 'small' && !added ) {
      appendStylesheet();
      added = true;
    }
  }

  init();

  window.addEventListener( 'resize', debounce( onResize, 500 ) );


});

export default undefined;
